import React from 'react';
import ReactDOM from 'react-dom/client';
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from 'react-router-dom';

import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';

import App from './App';
import Homescreen from './Screens/Homescreen';
import AboutUsscreen from './Screens/AboutUsscreen';
import QualityPolicyScreen from './Screens/QualityPolicyscreen';
import QualityCertificationscreen from './Screens/QualityCertificationscreen';
import OurProductscreen from './Screens/OurProductscreen';
import OurCapabilitiesscreen from './Screens/OurCapabilities';
import ContactUsscreen from './Screens/ContactUsscreen';
import reportWebVitals from './reportWebVitals';
import Galleryscreen from './Screens/Careersscreen';

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<App />}>
      <Route index element={<Homescreen />} />
      <Route path='aboutus' element={<AboutUsscreen />} />
      <Route path="/qualitypolicy" element={<QualityPolicyScreen />} />
      <Route path='/qualitycertification' element={<QualityCertificationscreen />} />
      <Route path="/products" element={<OurProductscreen />} />
      <Route path="/capabilities" element={<OurCapabilitiesscreen />} />
      <Route path="/gallery" element={<Galleryscreen />} />
      <Route path="/contact" element={<ContactUsscreen />} />
    </Route>
  )
);

const root = ReactDOM.createRoot(
  document.getElementById('root')
);

root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

reportWebVitals();
